<template>
  <div class="acties pt-12">
    <v-container fluid black :class="[$vuetify.breakpoint.mdAndUp ? 'py-12' : 'px-0']">
      <v-container class="max-container mx-auto" :class="[$vuetify.breakpoint.mdAndUp ? '' : 'px-0']">
        <v-layout pt-12 row wrap :class="[$vuetify.breakpoint.mdAndUp ? 'px-4' : 'px-3']">
          <v-flex xs12>
            <s-card>
              <v-card-title class="px-0 white--text">
                {{ pageContent.pageSub2 }}
                <v-btn @click="actionFilter = true" icon small class="ml-2"> <v-icon>filter_list</v-icon> </v-btn>
              </v-card-title>
              <v-data-table dark
                :headers="headers"
                :items="actions.data"
                :server-items-length="actions.recordsTotal"
                :options.sync="actionsOptions"
                :items-per-page="25"
                :loading="actionsLoading"
                class="elevation-0 big-headers mt-4 transparent dark-table p4-table"
                :footer-props="{ itemsPerPageOptions: [25,50,75,100], itemsPerPageText: 'Rijen per pagina' }"
                :class="[$vuetify.breakpoint.mdAndUp ? 'white-borders' : 'mobile-table']"
                dense
                loading-text="laden..."
                no-results-text="geen acties beschikbaar"
                no-data-text="geen acties beschikbaar"
              >
                <template v-slot:item.date="{ item }">
                  <span class="text-no-wrap d-flex" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']">
                    <span class="white--text no-dec mr-2"> 
                      {{ toDate(item.date) }}</span>
                  </span>
                </template>
                <template v-slot:item.state="{ item }">
                  <span class="text-no-wrap d-flex" >
                    <span class="white--text no-dec mr-2"> 

                      <div class="status-indicator mr-1">
                        <div class="status-filler" :class="[item.state === 'open' ? 'red' : (item.state === 'In behandeling' ? 'orange' : 'green')]"></div>
                      </div>
                      {{ item.state }}</span>
                  </span>
                </template> 
                <template v-slot:item.priority="{ item }">
                  <span class="text-no-wrap d-flex" @click="openDialog(item)" style="cursor: pointer">
                      <v-icon v-if="item.priority === 'hoog'" small class="mr-2 color-neg ">fas fa-exclamation-circle</v-icon>
                      <span class="white--text no-dec mr-2">{{ item.priority }}</span>
                      <v-icon class="ml-auto small-icon" >fas fa-chevron-right</v-icon>
                  </span>
                </template>
                <template v-slot:item.ean="{ item }">
                  <span class="text-no-wrap w-100 d-block" :class="[$vuetify.breakpoint.mdAndUp ? 'has-side-border position-relative' : '']" @click="toConnections({ean:item.ean})">
                    <a class="white--text no-dec d-flex">
                      {{ item.ean }}
                      <v-spacer></v-spacer>
                      <v-icon class="ml-auto small-icon">fas fa-chevron-right</v-icon>
                    </a>
                    
                  </span>
                </template>
              </v-data-table>
            </s-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
   <filters title="Filter acties" :open.sync="actionFilter" :open="actionFilter" :options="actionFilterOptions" :values="actionsOptions.filters" @filter="filter"></filters>
   <action-modal :action="currentitem" :dialog.sync="showDialog" :dialog="showDialog" @actionUpdated="actionChanged"></action-modal>
  </div>
</template>

<script>

import Operator from '@/components/Operator';
import Filters from '@/components/Filters';
import ActionModal from '@/components/ActionModal';

export default {

  name: 'acties',
  components: { Operator, Filters, ActionModal },
  data() {
    return {
      showDialog: false,
      currentitem:null,
      errors:[],
      actions:
      {
        data:[],
        recordsTotal:0,
        page:1,
        categories:[],
      },
      categories:[],
      headers: [
        { text: 'Actie', value: 'label', align: 'left',},
        { text: 'Postcode', value: 'postal' },
        { text: 'Huisnr', value: 'number' },
        { text: 'EAN', value: 'ean' },
        { text: 'Type', value: 'type' },
        { text: 'Categorie', value: 'category' },
        { text: 'Datum', value: 'date' },
        { text: 'Prioriteit', value: 'priority' },
        { text: 'Status', value: 'state' },
      ],
      actionFilterOptions:
      {
        label:{type:'text', label:'Actie'},
        postal:{type:'text', label:'Postcode'},
        number:{type:'text', label:'Huisnummer'},
        ean:{type:'text', label:'Ean'},
        type:{type:'select', label:'Type', options:[{ text: 'allemaal', value: null}, { text: 'elektriciteit', value: 1}, { text: 'gas', value: 3}, { text: 'teruglevering', value: 2}]},
        category:{type:'select', label:'Categorie', options:[{text:'allemaal', value: null}] },
        date:{type:'date', label:'Datum'},
        priority:{type:'select', label:'Prioriteit', options:[{ text: 'allemaal', value: null}, { text: 'hoog', value: 1}, { text: 'laag', value: 2}]},
        state:{type:'select', label:'Status', options:[{ text: 'allemaal', value: null}, { text: 'open', value: 1}, { text: 'in behandeling', value: 2}, { text: 'voltooid', value: 3}]},
      },
      actionFilter: false,
      actionsLoading: true,
      pageContent: {
        pageSub2: 'Acties',
      },

    };
  },
  methods:{
    loadActions(){
      
      this.actionsLoading = true;
      this.$store.dispatch('loadActions', this.actionsOptions).then
      ((data) => {
        this.actions = data;
        this.actionFilterOptions.category.options = data.categories;
        this.actionsLoading = false;
      });
    },
    filter(filters)
    {
      let temp = JSON.parse(JSON.stringify(this.actionsOptions));
      temp.filters = filters;
      temp.page = 1;
      this.actionsOptions = JSON.parse(JSON.stringify(temp));
    },
    actionChanged(action)
    {
      this.showDialog = false;
      this.currentitem = action;
      this.showDialog = true;
      this.loadActions();
    },
    openDialog(action)
    {
      this.currentitem = action;
      this.showDialog = true;
    },
  },
  computed: {
    actionsOptions: {
        get: function()
        {
          return this.$store.state.actionsOptions;
        },
        set: function(value)
        {
          this.$store.state.actionsOptions = value;
        }
    },
    permissions : {
      get() {
        return this.$store.getters.permissions;
      }
    }
  },
  watch:
  {
    actionsOptions: {
      deep:true,
          handler (newState, old) {
           this.loadActions();
      }
    }
	},

};

</script>